import { create } from 'zustand'
import { GameUIMessageScope, GameUIMessageType, MenuSectionId, ToggleLeftHandModeMessage } from 'game-ui-types'
import { getLocalStorageFlagValue } from '@utils/misc'
// import { useSpinButtonSectionStore } from '@stores'

interface MenuStore {
    isQuickSpinOn: boolean
    isBatterySaverOn: boolean
    isLeftHandModeOn: boolean
    shouldOpenDefaultSection: boolean
    targetMenuSectionId: MenuSectionId | null
    setIsQuickSpinOn: (enabled: boolean) => void
    setIsBatterySaverOn: () => void
    setIsLeftHandModeOn: () => void
    setShouldOpenDefaultSection: (value: boolean) => void
    setTargetMenuSectionId: (id: MenuSectionId | null) => void
    // autoplay
    balanceDecreasesValue: number
    balanceDecreasesMax: number
    winExceedsValue: number
    winExceedsMax: number
    balanceIncreasesValue: number
    balanceIncreasesMax: number
    currentSelectedTabIndex: number
    setBalanceDecreasesValue: (value: number) => void
    setBalanceDecreasesMax: (max: number) => void
    setWinExceedsValue: (value: number) => void
    setWinExceedsMax: (max: number) => void
    setBalanceIncreasesValue: (value: number) => void
    setBalanceIncreasesMax: (max: number) => void
    setSelectedTabIndex: (value: number) => void
}

export const useMenuStore = create<MenuStore>((set) => ({
    isQuickSpinOn: false,
    isBatterySaverOn: getLocalStorageFlagValue('isBatterySaverActive', false),
    isLeftHandModeOn: false,
    shouldOpenDefaultSection: true,
    targetMenuSectionId: null,

    setIsQuickSpinOn: (enabled) => {
        set({ isQuickSpinOn: enabled })
    },
    setIsBatterySaverOn: () => set((state) => ({ isBatterySaverOn: !state.isBatterySaverOn })),
    setIsLeftHandModeOn: () =>
        set((state) => {
            const toggleLeftHandModeMessage: ToggleLeftHandModeMessage | unknown = {
                type: GameUIMessageType.TOGGLE_LEFT_HAND_MODE,
                payload: !state.isLeftHandModeOn,
                scope: GameUIMessageScope.MENU,
            }

            window.postMessage(toggleLeftHandModeMessage)

            return { isLeftHandModeOn: !state.isLeftHandModeOn }
        }),

    setShouldOpenDefaultSection: (value) => {
        set({ shouldOpenDefaultSection: value })
    },

    setTargetMenuSectionId: (id) => {
        set({ targetMenuSectionId: id })
    },

    // autoplay
    balanceDecreasesValue: 0,
    balanceDecreasesMax: 10000,
    winExceedsValue: 0,
    winExceedsMax: 10000,
    balanceIncreasesValue: 0,
    balanceIncreasesMax: 10000,
    currentSelectedTabIndex: 0,

    setBalanceDecreasesValue: (value) => set({ balanceDecreasesValue: value }),
    setBalanceDecreasesMax: (max) =>
        set((state) => ({
            balanceDecreasesMax: max,
            balanceDecreasesValue: Math.min(state.balanceDecreasesValue, max),
        })),
    setWinExceedsValue: (value) => set({ winExceedsValue: value }),
    setWinExceedsMax: (max) =>
        set((state) => ({
            winExceedsMax: max,
            winExceedsValue: Math.min(state.winExceedsValue, max),
        })),
    setBalanceIncreasesValue: (value) => set({ balanceIncreasesValue: value }),
    setBalanceIncreasesMax: (max) =>
        set((state) => ({
            balanceIncreasesMax: max,
            balanceIncreasesValue: Math.min(state.balanceIncreasesValue, max),
        })),
    setSelectedTabIndex: (value) => set({ currentSelectedTabIndex: value }),
}))
